import { GlobalStyles } from '@mui/system'

//
// 1. Global CSS overrides (applied once per app)
//
export const dataGridGlobalStyles = {
  '.MuiDataGrid-toolbarQuickFilter .MuiInput-underline::before, .MuiDataGrid-panelContent .MuiInput-underline::before':
    {
      borderRadius: '8px',
    },

  '.MuiDataGrid-toolbarQuickFilter .MuiInput-underline:hover:not(.Mui-disabled)::before, .MuiDataGrid-panelContent .MuiInput-underline:hover:not(.Mui-disabled)::before':
    {
      borderBottomColor: '#5D729E',
    },

  '.MuiDataGrid-toolbarQuickFilter .MuiInput-underline::after, .MuiDataGrid-panelContent .MuiInput-underline::after':
    {
      borderBottomColor: '#2370ED',
      borderRadius: '8px',
      height: '0px',
      transition:
        'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms, height 200ms cubic-bezier(0.0, 0, 0.2, 1) 100ms',
    },

  '.MuiDataGrid-toolbarQuickFilter .MuiInput-underline.Mui-focused::after, .MuiDataGrid-panelContent .MuiInput-underline.Mui-focused::after':
    {
      height: '20px',
    },

  '.MuiDataGrid-toolbarContainer > div > button, .MuiDataGrid-toolbarContainer > div > button:hover, .MuiDataGrid-toolbarContainer > div > button:focus:not(:hover), .MuiDataGrid-panelContent label.Mui-focused':
    {
      color: '#2370ED',
    },
}

//
// 2. Component-level DataGrid SX styles
//
export const dataGridBaseSx = {
  '&.MuiDataGrid-root': {
    border: 'none',
  },

  '& .MuiDataGrid-columnHeaders': {
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 1,
  },

  '& .MuiTablePagination-root': {
    overflow: 'unset',
  },

  '& .MuiTablePagination-toolbar .MuiInputBase-root': {
    width: 'auto !important',
  },

  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },

  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
    {
      outline: 'none',
    },

  '& .MuiCircularProgress-root': {
    color: '#2370ED',
  },
}

//
// Optional: A convenience wrapper so you can use <DataGridStyles /> directly
//
export const DataGridStyles = () => (
  <GlobalStyles styles={dataGridGlobalStyles} />
)
